
import Router from "@/router"
import store  from '@/store'
import{Message} from 'element-ui'
// 路由跳转前触发
Router.beforeEach((to, from, next) => {
	if(!store.state.user.token){
		if(to.path!='/login'){
			next({ path: '/login' });
		}else{
			next();
		}
	}else{
		let flag = parseInt(store.state.user.userinfo.flag)
		if(to.meta.requiresAuth){
			if(to.meta.requiresAuth.includes(flag)){
				next();
			}else{
				Message.error("无权访问")
				next(from.fullPath);
			}
		}else{
			next();
		}
	}
});


